import React from "react";
import classNames from "classnames";
import Button from "components/Button";
import classes from "./styles.module.scss";

const languages = {
    en: "English",
    fr: "French",
};

const LangButton = ({ lang, setLang, className }) => {
    const handleLangChange = (value) => setLang(value);

    return (
        <div className={`${classes.langBtnsContainer} ${className}`}>
            {Object.keys(languages).map((code) => (
                <Button
                    key={code}
                    type="hollow"
                    className={classNames({ [classes.selected]: lang === code })}
                    onClick={() => handleLangChange(code)}
                >
                    {languages[code]}
                </Button>
            ))}
        </div>
    );
};

export default LangButton;